export default __webpack_public_path__ + "duplicate-scene.svg";